import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { mGetDict } from '@/api/main/system'
export interface ICacheState {
  systemType: Array<object>
  dicts: object
}

@Module({ dynamic: true, store, name: 'cache' })
class Cache extends VuexModule implements ICacheState {
  public systemType:Array<object> = []
  public dicts:object = { }

  @Mutation
  private SETSYSTEMTYPE (systemType: Array<object>) {
    this.systemType = systemType
  }

  @Mutation
  private SETDICTS (dicts: object) {
    this.dicts = { ...this.dicts, ...dicts }
  }

  @Mutation
  private shopLabel (dicts: any) {
    (this.dicts as any).shopLabel = dicts
  }

  @Action
  public async GetSystemType () {
    // const res = await systemType()
    // this.SETSYSTEMTYPE(res.data)
  }

  @Action
  public async GetDicts (params:object) {
    const res = await mGetDict(params)
    this.SETDICTS(res.data)
  }
}

export const CacheModule = getModule(Cache)
